/**
 * The composer's text colours (see addTextColorButton.tsx): those phpBB
 * members used the most (counted in the 3,426 migrated posts with a
 * [color], 2026-10-19 - red 1,150, green 570, dark blue 313...), all
 * readable on the forum's white background. Each name is a key under
 * champis-forum.forum.text_color.colors.
 */
export const TEXT_COLORS = [{
  value: '#ff0000',
  name: 'red'
}, {
  value: '#bf0000',
  name: 'dark_red'
}, {
  value: '#ff8000',
  name: 'orange'
}, {
  value: '#008000',
  name: 'green'
}, {
  value: '#00bf00',
  name: 'light_green'
}, {
  value: '#0000bf',
  name: 'blue'
}, {
  value: '#800080',
  name: 'purple'
}, {
  value: '#808080',
  name: 'gray'
}];

/**
 * What the server's [color=…] takes - flarum/bbcode's COLOR, its
 * attribute filtered by s9e's #color (ColorFilter): anything else stays
 * raw text once published, so the rich editor leaves it as text too.
 */
export const COLOR_VALUE = /^(?:#[0-9a-f]{3,6}|rgb\(\d{1,3}, *\d{1,3}, *\d{1,3}\)|[a-z]+)$/i;
export function sameColor(a, b) {
  return !!a && a.toLowerCase() === b.toLowerCase();
}
flarum.reg.add('champis-forum', 'forum/utils/textColors', { TEXT_COLORS: TEXT_COLORS,COLOR_VALUE: COLOR_VALUE,sameColor: sameColor, });